import axios from '../http'
import global from '@/constants/Global.constants'

export default {
  getDesignerList (params) { // 获取设计师列表
    return axios.post(global.PMC_DESIGNER + '/findPmcProductDesigner', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/pmc/designer.js